import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=2f458835&scoped=true&"
import script from "./StoryCard.vue?vue&type=script&lang=ts&"
export * from "./StoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./StoryCard.vue?vue&type=style&index=0&id=2f458835&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f458835",
  null
  
)

export default component.exports